/**
 * Sprint 49 — F48 PWA service worker registration.
 *
 * Mounted from index.tsx after React boots. Only registers in
 * production builds to keep CRA's hot-reload dev loop working.
 * Listens for "updatefound" so we can show a "new version available"
 * toast in the UI; see PWAUpdateBanner for the consumer.
 */

const SW_URL = '/service-worker.js';

type UpdateHandler = () => void;

export function registerServiceWorker(opts: { onUpdate?: UpdateHandler } = {}): void {
  if (!('serviceWorker' in navigator)) return;
  // Don't fight CRA's webpack-dev-server. SW is a production-only
  // concern; dev rebuilds would just thrash the cache.
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // A new SW has taken over; the next nav will use it.
              // Surface a UI hint so the user can refresh.
              opts.onUpdate?.();
            }
          };
        };
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Service worker registration failed:', err);
      });
  });
}

export function unregisterServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => {});
}
